const orderServicio =
  [
    {
      titulo: "general_information",
      id: "info-panel",
      create: [
        {
          type: 'Select',
          label: 'company',
          class: 'col-md-3 input-form',
          placeHolder: 'company',
          name: 'customerid',
          selectCatalogName: "Entities",
          id: 'CustomerId',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'reference_po',
          placeHolder: 'reference',
          name: 'RefCustomer',
          class: 'col-md-3 input-form',
          id: 'RefCustomer',
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Select',
          options: 'IncotermCode',
          label: 'incoterm',
          name: 'IncotermCode',

          class: 'col-md-3 input-form',
          id: 'IncotermCode',
          selectCatalogName: "Incoterm",
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Date',
          label: 'required_at_destination',
          format: "dd-MM-yyyy",
          placeHolder: 'required_at_destination',
          name: 'RequiredDateDestination',
          class: 'col-md-3 input-form',
          id: 'RequiredDateDestination',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          validation: "numeric",
          label: 'po_visibility_gross_weight',
          class: 'col-md-3 input-form',
          placeHolder: 'po_visibility_gross_weight',
          name: 'GrossWeight',
          id: 'GrossWeight',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Select',
          options: 'UOMWeight',
          label: 'po_visibility_uom',
          name: 'UOMWeight',

          class: 'col-md-3 input-form',
          id: 'UOMWeight',
          selectCatalogName: "UOMWeight",
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          validation: "numeric",
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: 'qty_ordered',
          name: 'QTYOrdered',
          id: 'QTYOrdered',
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Select',
          options: 'UOMQty',
          label: 'UOM',
          name: 'UOMOrdered',

          class: 'col-md-3 input-form',
          id: 'UOMOrdered',
          selectCatalogName: "UOMQty",
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'length',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'length',
          name: 'Length',
          id: 'Length',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'width',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'width',
          name: 'Width',
          id: 'Width',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'height',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'height',
          name: 'Height',
          id: 'Height',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Select',
          options: 'UOMDimension',
          label: 'UOM',
          name: 'UOMDimensions',

          class: 'col-md-3 input-form',
          id: 'UOMDimensions',
          selectCatalogName: "UOMDimension",
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'po_visibility_total_weight',
          validation: "numeric",
          class: 'col-md-3 input-form',
          name: 'TotalWeight',
          id: 'TotalWeight',
          style: { fontWeight: "bold" },
          required: false,
          disabled: true
        },
        {
          type: 'Select',
          options: 'UOMWeight',
          label: 'po_visibility_total_weight_uom',
          name: 'UOMWeight',
          class: 'col-md-3 input-form',
          id: 'UOMWeight',
          selectCatalogName: "UOMWeight",
          style: { fontWeight: "bold" },
          required: false,
          disabled: true
        },
        {
          type: 'TextArea',
          label: 'general_desc_goods',
          name: 'DescriptionGoods',

          class: 'col-md-12 input-form',
          id: 'DescriptionGoods',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'TextArea',
          label: 'additional_references',
          name: 'AdditionalReferences',

          class: 'col-md-12 input-form',
          id: 'AdditionalReferences',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      edit: [
        {
          type: 'Label',
          label: 'company',
          class: 'col-md-3 input-form',
          placeHolder: 'company',
          name: 'customerid',
          // selectCatalogName: "Entities",
          // id: 'CustomerId',
          id: 'CustomerName',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'reference',
          placeHolder: 'reference',
          name: 'RefCustomer',
          class: 'col-md-3 input-form',
          id: 'RefCustomer',
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Select',
          options: 'IncotermCode',
          label: 'incoterm',
          name: 'IncotermCode',

          class: 'col-md-3 input-form',
          id: 'IncotermCode',
          selectCatalogName: "Incoterm",
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Date',
          label: 'required_at_destination',
          format: "dd-MM-yyyy",
          placeHolder: 'required_at_destination',
          name: 'RequiredDateDestination',
          class: 'col-md-3 input-form',
          id: 'RequiredDateDestination',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'po_visibility_gross_weight',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'po_visibility_gross_weight',
          name: 'GrossWeight',
          id: 'GrossWeight',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Select',
          options: 'UOMWeight',
          label: 'po_visibility_uom',
          name: 'UOMWeight',

          class: 'col-md-3 input-form',
          id: 'UOMWeight',
          selectCatalogName: "UOMWeight",
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'qty_ordered',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'qty_ordered',
          name: 'QTYOrdered',
          id: 'QTYOrdered',
          style: { fontWeight: "bold" },
          required: true
        },

        {
          type: 'Select',
          options: 'UOMQty',
          label: 'UOM',
          name: 'UOMOrdered',

          class: 'col-md-3 input-form',
          id: 'UOMOrdered',
          selectCatalogName: "UOMQty",
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'length',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'length',
          name: 'Length',
          id: 'Length',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'width',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'width',
          name: 'Width',
          id: 'Width',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'height',
          validation: "numeric",
          class: 'col-md-3 input-form',
          placeHolder: 'height',
          name: 'Height',
          id: 'Height',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Select',
          options: 'UOMDimension',
          label: 'UOM',
          name: 'UOMDimensions',

          class: 'col-md-3 input-form',
          id: 'UOMDimensions',
          selectCatalogName: "UOMDimension",
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Input',
          label: 'po_visibility_total_weight',
          class: 'col-md-3 input-form',
          placeHolder: 'po_visibility_total_weight',
          name: 'TotalWeight',
          id: 'TotalWeight',
          style: { fontWeight: "bold" },
          required: false,
          disabled: true
        },
        {
          type: 'Select',
          options: 'UOMWeight',
          label: 'po_visibility_total_weight_uom',
          name: 'UOMWeight',
          class: 'col-md-3 input-form',
          id: 'UOMWeight',
          selectCatalogName: "UOMWeight",
          style: { fontWeight: "bold" },
          required: false,
          disabled: true
        },
        {
          type: 'TextArea',
          label: 'general_description_goods_colon',
          name: 'DescriptionGoods',

          class: 'col-md-12 input-form',
          id: 'DescriptionGoods',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'TextArea',
          label: 'additional_references',
          name: 'AdditionalReferences',

          class: 'col-md-12 input-form',
          id: 'AdditionalReferences',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      previewForm: [
        {
          type: 'Label',
          label: 'company',
          class: 'col-md-3 input-form',
          placeHolder: 'company',
          name: 'CustomerName',
          id: 'CustomerName',
        },
        {
          type: 'Label',
          label: 'request',
          placeHolder: 'request',
          name: 'OrderNumber',
          class: 'col-md-3 input-form',
          id: 'OrderNumber'
        },

        {
          type: 'Label',
          label: 'incoterm',
          name: 'Incoterm',
          class: 'col-md-3 input-form',
          id: 'Incoterm',
        },

        {
          type: 'Label',
          label: 'required_at_destination',
          format: "dd-MM-yyyy",
          placeHolder: 'required_at_destination',
          name: 'RequiredDateDestination',
          class: 'col-md-3 input-form',
          id: 'RequiredDateDestination'
        },
        {
          type: 'LabelNumber',
          label: 'po_visibility_gross_weight',
          class: 'col-md-3 input-form',
          placeHolder: 'po_visibility_gross_weight',
          name: 'GrossWeight',
          id: 'GrossWeight',
          format: 'weight',
        },
        {
          type: 'Label',
          options: 'UOM',
          label: 'po_visibility_uom',
          name: 'UOMWeightDescription',
          class: 'col-md-3 input-form',
          id: 'UOMWeightDescription',
        },
        {
          type: 'LabelNumber',
          label: 'qty_ordered',
          class: 'col-md-3 input-form',
          placeHolder: 'qty_ordered',
          name: 'QTYOrdered',
          id: 'QTYOrdered'
        },

        {
          type: 'Label',
          options: 'UOM',
          label: 'UOM',
          name: 'UOMOrderedDescription',
          class: 'col-md-3 input-form',
          id: 'UOMOrderedDescription'
        },
        {
          type: 'LabelNumber',
          label: 'length',
          class: 'col-md-3 input-form',
          placeHolder: 'length',
          name: 'Length',
          id: 'Length',
          format: 'dimension',
        },
        {
          type: 'LabelNumber',
          label: 'width',
          class: 'col-md-3 input-form',
          placeHolder: 'width',
          name: 'Width',
          id: 'Width',
          format: 'dimension',
        },
        {
          type: 'LabelNumber',
          label: 'height',
          class: 'col-md-3 input-form',
          placeHolder: 'height',
          name: 'Height',
          id: 'Height',
          format: 'dimension',
        },

        {
          type: 'Label',
          options: 'UOM',
          label: 'UOM',
          name: 'UOMDimensionsDescription',
          class: 'col-md-3 input-form',
          id: 'UOMDimensionsDescription',
        },
        {
          type: 'LabelNumber',
          label: 'po_visibility_total_weight',
          name: 'TotalWeight',
          class: 'col-md-3 input-form',
          id: 'TotalWeight',
          format: 'weight',
        },
        {
          type: 'Label',
          label: 'po_visibility_total_weight_uom',
          name: 'TotalWeightUOMDescription',
          class: 'col-md-3 input-form',
          id: 'TotalWeightUOMDescription',
        },
        {
          type: 'Label',
          label: 'general_description_goods_colon',
          name: 'DescriptionGoods',
          class: 'col-md-12 input-form margin-top-euro label-euro',
          id: 'DescriptionGoods'
        }, {
          type: 'Label',
          label: 'additional_references',
          name: 'AdditionalReferences',
          class: 'col-md-12 input-form label-euro',
          id: 'AdditionalReferences'
        }

      ]
    },
    {
      titulo: "organizations",
      logo: "entidades",
      id: "entidades-panel",
      create: [
        {
          type: 'CustomEntidades',
          class: 'col-md-12 input-form'
        }
      ],
      edit: [
        {
          type: 'CustomEntidades',
          class: 'col-md-12 input-form'
        }
      ],
      previewForm: [
        {
          type: 'CustomEntidades',
          class: 'col-md-12 input-form'
        }
      ]
    }, {
      titulo: "instructions_to_euro",
      create: [
        {
          type: 'Select',
          label: 'transport_mode',
          class: 'col-md-3 input-form',
          placeHolder: 'transport_mode',
          name: 'TransportModeId',
          selectCatalogName: "TransportModes",
          id: 'TransportModeId',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'Select',
          label: 'freight_terms',
          class: 'col-md-3 input-form',
          placeHolder: 'freight_terms',
          name: 'FreightTermCode',
          selectCatalogName: "FreightTerms",
          id: 'FreightTermCode',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'Space',
          class: 'col-md-6 input-form',
        },
        {
          type: 'Input',
          label: 'pickup_reception_goods',
          class: 'col-md-6 input-form',
          name: 'PickupGoods',
          id: 'PickupGoods',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'place_transefer_goods',
          class: 'col-md-6 input-form',
          name: 'SpecialInstructions',
          id: 'SpecialInstructions',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'TextArea',
          label: 'special_instruccions',
          class: 'col-md-6 input-form',
          name: 'DeliveryGoods',
          id: 'DeliveryGoods',
          style: { fontWeight: "bold" },
          required: false
        },
      ],
      edit: [
        {
          type: 'Select',
          label: 'transport_mode',
          class: 'col-md-3 input-form',
          placeHolder: 'transport_mode',
          name: 'TransportModeId',
          selectCatalogName: "TransportModes",
          id: 'TransportModeId',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'Select',
          label: 'freight_terms',
          class: 'col-md-3 input-form',
          placeHolder: 'freight_terms',
          name: 'FreightTermCode',
          selectCatalogName: "FreightTerms",
          id: 'FreightTermCode',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'Space',
          class: 'col-md-6 input-form',
        },
        {
          type: 'Input',
          label: 'pickup_reception_goods',
          class: 'col-md-6 input-form',
          name: 'PickupGoods',
          id: 'PickupGoods',
          style: { fontWeight: "bold" },
          required: true
        },
        {
          type: 'Input',
          label: 'place_transefer_goods',
          class: 'col-md-6 input-form',
          name: 'SpecialInstructions',
          id: 'SpecialInstructions',
          style: { fontWeight: "bold" },
          required: true
        }, {
          type: 'TextArea',
          label: 'special_instruccions',
          class: 'col-md-6 input-form',
          name: 'DeliveryGoods',
          id: 'DeliveryGoods',
          style: { fontWeight: "bold" },
          required: false
        },
      ],
      previewForm: [

        {
          type: 'Label',
          label: 'transport_mode',
          name: 'TransportMode',

          class: 'col-md-3 input-form',
          id: 'TransportMode',
          style: {}
        },
        {
          type: 'Label',
          label: 'freight_terms',
          name: 'tramoContratado',

          class: 'col-md-3 input-form',
          id: 'FreightTerm',
          style: {}
        },
        {
          type: 'Space',
          class: 'col-md-6 input-form',
        },
        {
          type: 'Label',
          label: 'pickup_reception_goods',
          name: 'PickupGoods',

          class: 'col-md-6 input-form',
          id: 'PickupGoods',
          style: {}
        },
        {
          type: 'Label',
          label: 'place_transefer_goods',
          name: 'SpecialInstructions',

          class: 'col-md-6 input-form',
          id: 'SpecialInstructions',
          style: {}
        },
        {
          type: 'Label',
          label: 'special_instruccions',
          name: 'DeliveryGoods',

          class: 'col-md-6 input-form',
          id: 'DeliveryGoods',
          style: {}
        }
      ]
    }, {
      titulo: "origin",
      logo: "calendario",
      id: "origen-panel",
      create: [
        {
          type: 'Date',
          label: 'cargo_ready_commitment',
          format: "dd-MM-yyyy",
          placeHolder: 'cargo_ready_commitment',
          name: 'PromiseCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'PromiseCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        },

        {
          type: 'Date',
          label: 'cargo_ready_est',
          format: "dd-MM-yyyy",
          placeHolder: 'cargo_ready_est',
          name: 'EstCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'EstCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'actual_cargo_ready',
          format: "dd-MM-yyyy",
          placeHolder: 'actual_cargo_ready',
          name: 'ActualCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'ActualCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        }, {
          type: 'Date',
          label: 'pickup_reception_estimated',
          format: "dd-MM-yyyy",
          placeHolder: 'pickup_reception_estimated',
          name: 'EstPickupDate',
          class: 'col-md-3 input-form',
          id: 'EstPickupDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'pickup_reception_real',
          format: "dd-MM-yyyy",
          placeHolder: 'pickup_reception_real',
          name: 'ActualPickupDate',
          class: 'col-md-3 input-form',
          id: 'ActualPickupDate',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      edit: [
        {
          type: 'Date',
          label: 'cargo_ready_commitment',
          format: "dd-MM-yyyy",
          placeHolder: 'cargo_ready_commitment',
          name: 'PromiseCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'PromiseCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        },

        {
          type: 'Date',
          label: 'cargo_ready_est',
          format: "dd-MM-yyyy",
          placeHolder: 'cargo_ready_est',
          name: 'EstCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'EstCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'actual_cargo_ready',
          format: "dd-MM-yyyy",
          placeHolder: 'actual_cargo_ready',
          name: 'ActualCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'ActualCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        }, {
          type: 'Date',
          label: 'pickup_reception_estimated',
          format: "dd-MM-yyyy",
          placeHolder: 'pickup_reception_estimated',
          name: 'EstPickupDate',
          class: 'col-md-3 input-form',
          id: 'EstPickupDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'pickup_reception_real',
          format: "dd-MM-yyyy",
          placeHolder: 'pickup_reception_real',
          name: 'ActualPickupDate',
          class: 'col-md-3 input-form',
          id: 'ActualPickupDate',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      previewForm: [
        {
          type: 'Label',
          label: 'cargo_ready_commitment',
          placeHolder: 'cargo_ready_commitment',
          name: 'PromiseCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'PromiseCargoReadyDate'
        },

        {
          type: 'Label',
          label: 'cargo_ready_est',
          format: "dd-MM-yyyy",
          placeHolder: 'cargo_ready_est',
          name: 'EstCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'EstCargoReadyDate'
        },
        {
          type: 'Label',
          label: 'actual_cargo_ready',
          format: "dd-MM-yyyy",
          placeHolder: 'actual_cargo_ready',
          name: 'ActualCargoReadyDate',
          class: 'col-md-2 input-form',
          id: 'ActualCargoReadyDate',
          style: { fontWeight: "bold" },
          required: false
        }, {
          type: 'Label',
          label: 'pickup_reception_estimated',
          placeHolder: 'pickup_reception_estimated',
          name: 'EstPickupDate',
          class: 'col-md-3 input-form',
          id: 'EstPickupDate',
        },
        {
          type: 'Label',
          label: 'pickup_reception_real',
          placeHolder: 'pickup_reception_real',
          name: 'ActualPickupDate',
          class: 'col-md-3 input-form',
          id: 'ActualPickupDate'
        }
      ]
    },
    {
      titulo: "destination",
      logo: "calendario",
      id: "destino-panel",
      create: [
        {
          type: 'Date',
          label: 'transit_to_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'transit_to_final_dest',
          name: 'TransitToFinalDestinationDate',
          class: 'col-md-4 input-form',
          id: 'TransitToFinalDestinationDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'arrival_at_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'arrival_at_final_dest',
          name: 'FinalDestinationArrivalDate',
          class: 'col-md-3 input-form',
          id: 'FinalDestinationArrivalDate',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      edit: [
        {
          type: 'Date',
          label: 'transit_to_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'transit_to_final_dest',
          name: 'TransitToFinalDestinationDate',
          class: 'col-md-4 input-form',
          id: 'TransitToFinalDestinationDate',
          style: { fontWeight: "bold" },
          required: false
        },
        {
          type: 'Date',
          label: 'arrival_at_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'arrival_at_final_dest',
          name: 'FinalDestinationArrivalDate',
          class: 'col-md-3 input-form',
          id: 'FinalDestinationArrivalDate',
          style: { fontWeight: "bold" },
          required: false
        }
      ],
      previewForm: [
        {
          type: 'Label',
          label: 'transit_to_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'transit_to_final_dest',
          name: 'TransitToFinalDestinationDate',
          class: 'col-md-4 input-form',
          id: 'TransitToFinalDestinationDate'
        },
        {
          type: 'Label',
          label: 'arrival_at_final_dest',
          format: "dd-MM-yyyy",
          placeHolder: 'arrival_at_final_dest',
          name: 'FinalDestinationArrivalDate',
          class: 'col-md-3 input-form',
          id: 'FinalDestinationArrivalDate'
        }
      ]

    }
  ]


export default orderServicio